import {useTitle} from 'hooks';
import {NavbarCommon} from 'components';
import AcceptInvite from './components/AcceptInvite';

interface IPageAcceptInviteProps {}

const PageAcceptInvite = ({}: IPageAcceptInviteProps) => {
  useTitle('Accept Invite');
  return (
    <div className="min-h-screen flex flex-col">
      <NavbarCommon />
      <AcceptInvite />
    </div>
  );
};

export default PageAcceptInvite;
